import React from 'react';
import {connect} from "react-redux";
import {Link} from 'react-router-dom';
import {Icon, Checkbox, Button} from "spectre-react/dist/cjs";
import {getClientsById, getMachinesById, getReports, getSlotsHistory} from "../../selectors";
import {editReportPath} from "../../paths";
import {date1to2} from "../shared/utils";
import {fetchCSV} from "../../api";
import SlotHistoryModal from "./SlotHistoryModal";


class SlotsHistoryPage extends React.Component {
    state = {
        slotHistoryTable: [],
        slotHistoryById: {},

        isMoreThanOneHistoryItem: false,
        isOnlyUsedAndNew: false
    };

    modalController = undefined;
    receiveModalController = ({open, close}) => this.modalController = {open, close};

    openModal = (ev) => {
        const slotNumber = ev.currentTarget.parentElement.dataset.slotNumber;
        const historyItems = this.state.slotHistoryById[slotNumber];

        this.modalController.open(slotNumber, historyItems);
    };

    componentDidMount() {
        const { reports, clientsById, machinesById } = this.props;
        const { slotHistoryTable, slotHistoryById } = getSlotsHistory(reports, clientsById, machinesById);
        this.setState({ slotHistoryTable, slotHistoryById });
    }

    filterData = () => {
        let slotHistoryTable = this.state.slotHistoryTable;

        if (this.state.isMoreThanOneHistoryItem)
            slotHistoryTable = slotHistoryTable.filter(row => row.historyItemsCount > 1);

        if (this.state.isOnlyUsedAndNew)
            slotHistoryTable = slotHistoryTable.filter(row => row.firstMentionState && (row.firstMentionState !== "UNKNOWN"));

        return slotHistoryTable;
    }

    downloadCSV1 = () => {
        let output = `data:text/csv;charset=utf-8;"","Номер","Первое упоминание","Последнее упоминание","Число записей","Дней между упоминаниями","Время между упоминаниями","Состояние при первом упоминании"\n`;
        for (const item of this.state.slotHistoryTable)
             output += `"${item.number}","${item.firstMentionDate}","${item.lastMentionDate}","${item.historyItemsCount}","${item.daysBetweenMentions}","${item.daysBetweenMentionsStr}","${item.firstMentionState}"\n`;

        fetchCSV(output, `slots-${new Date().toISOString()}.csv`);
    };

    downloadCSV2 = () => {
        const { slotHistoryById } = this.state;

        // TODO: перенести в xlsx и на сервер

        const rows = Object.entries(slotHistoryById)
            .map(([slotId, items]) => {
                return items.map(item => [
                    slotId,
                    item.isMounted ? item.workDate : "",
                    item.isUnmounted ? item.workDate : "",
                    item.client?.name.replace(/"/g, "'"),
                    item.machine ? item.machine.serial : "",
                    item.machine ? `${item.machine.manufacturer} ${item.machine.model}` : "",
                    item.mountedSlotState || "",
                    item.phPosition,
                    item.phSerial,
                ])
            })
            .flat(1);

        const output = `data:text/csv;charset=utf-8;` +
            `"","Номер слота","Дата установки","Дата снятия","Клиент","Серийник принтера","Модель принтера","Статус уст. слота","Позиция головы","Серийник головы"\n` +
            rows.map(row => row.map(item => `"${item}"`).join(',')).join('\n');

        fetchCSV(output, `slots-by-id-${new Date().toISOString()}.csv`);
    };

    render() {
        const {isMoreThanOneHistoryItem, isOnlyUsedAndNew} = this.state;

        const slotHistoryTable = this.filterData();

        return (
            <div>
                <h1>Информация про слоты</h1>

                <SlotHistoryModal provideController={this.receiveModalController} />

                <div className="mb-4">
                    <Button primary small onClick={this.downloadCSV1}>
                        <Icon icon="download"/> CSV 1
                    </Button>

                    <Button primary small onClick={this.downloadCSV2} className="ml-2">
                        <Icon icon="download"/> CSV 2
                    </Button>
                </div>

                <div id="slots-history-table" className="custom-table custom-table-narrow">
                    <div className="table-row table-head">
                        {/*<div/>*/}
                        <div className="table-head-cell">
                            <div className="mb-2">Номер</div>
                        </div>
                        <div className="table-head-cell">
                            <div className="mb-2">Первое упоминание</div>
                        </div>
                        <div className="table-head-cell">
                            <div className="mb-2">Последнее упоминание</div>
                        </div>
                        <div className="table-head-cell">
                            <div className="mb-2">Число записей</div>
                            <Checkbox name="isMoreThanOneHistoryItem"
                                      value={isMoreThanOneHistoryItem}
                                      onChange={ev => this.setState({ isMoreThanOneHistoryItem: ev.target.checked })}
                            >
                                Больше 1
                            </Checkbox>
                        </div>
                        <div className="table-head-cell">
                            <div className="mb-2">Дней между уп-ми</div>
                        </div>
                        <div className="table-head-cell">
                            <div className="mb-2">Время между уп-ми</div>
                        </div>
                        <div className="table-head-cell">
                            <div className="mb-2">Состояние при первом уп-ии</div>
                            <Checkbox name="isMoreThanOneHistoryItem"
                                      value={isOnlyUsedAndNew}
                                      onChange={ev => this.setState({ isOnlyUsedAndNew: ev.target.checked })}
                            >
                                USED или NEW
                            </Checkbox>
                        </div>
                    </div>

                    {slotHistoryTable.map((item, index) =>
                        <div className="table-row" key={item.number} data-slot-number={item.number}>
                            {/*<div>{index}.</div>*/}
                            <div className="text-hover-underline c-hand" onClick={this.openModal}>
                                {item.number}
                            </div>
                            <div className="text-ellipsis">
                                <Link to={editReportPath(item.firstReportId)} target="_blank">{date1to2(item.firstMentionDate)} :: {item.firstClientName}</Link>
                            </div>
                            <div className="text-ellipsis">
                                <Link to={editReportPath(item.lastReportId)} target="_blank">{date1to2(item.lastMentionDate)} :: {item.lastClientName}</Link>
                            </div>
                            <div>{item.historyItemsCount}</div>
                            <div>{item.daysBetweenMentions}</div>
                            <div>{item.daysBetweenMentionsStr}</div>
                            <div>{item.firstMentionState}</div>
                        </div>
                    )}
                </div>
            </div>
        )
    }
}


function mapStateToProps(state, ownProps) {
    return {
        reports: getReports(state),
        clientsById: getClientsById(state),
        machinesById: getMachinesById(state),
    };
}

export default connect(mapStateToProps)(SlotsHistoryPage);